import { Link } from "react-router-dom";
import { IOpportunity } from "../../../constants/app.dto";
import { textChooser } from "../../../util/textChooser";
import { Avatar } from "../../avatar";
import { TextIcon } from "../../text_icon";
import { TagNew } from "../../tags/new";
import { Button } from "../../controls/button";
import { getHourDiff } from "../../../helpers/utilities";
import { useIdToText } from "../../../hooks/IdToText";
// import { FavoriteToggleBtn } from "../../controls/favorites";
import styled from 'styled-components';
import { useUser } from "../../../hooks/User";

const CardOpportunityWrapper = styled.div`
    margin: 18px 0;
    background: #FFFFFF;
    box-shadow: 2px 6px 12px rgba(19, 100, 125, 0.08);
    border-radius: 10px;
    padding: 20px;
    width: 100%;
    max-width: 1200px;
    display: flex;
    align-items: center;
    gap: 30px;

    @media (max-width: 768px){
        flex-direction: column;
        gap: 15px;
    }
`;

const AvatarWrapper = styled.div`
    span{
        height: 80px;
        width: 80px;
        background-color: rgba(0,0,0,0.05);
    }
`;

const ColInformation = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const ColControllers = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    height: 80px;
    width: 220px;

    @media (max-width: 768px){
        height: auto;
    }
`;

export const CardOpportunity = (props: IOpportunity) => {

    const {converIdToText} = useIdToText();
    const {createdAtText, isNew} = getHourDiff(props.createdAt);
    const userId = useUser().getDataByAttributeName("id");
    const opportunityUrl = `/opportunity/${props.id}/${props.companyId}`;

    return(
        <CardOpportunityWrapper>
            <AvatarWrapper>
                <Avatar url={props.company.logoImageUrl}/>
            </AvatarWrapper>
        
            <ColInformation>
                <div className="opportunity-name">
                    <Link 
                        className="heading sizeMd colorBlue styleBold"
                        to={`/opportunity/${props.id}/${props.companyId}`}
                    >
                        {props.name}
                    </Link>
                </div>
                <div className="company-name">
                    <span className="text sizeXs colorBlack" style={{marginRight: '10px'}}>
                        <strong>{props.company.name} - </strong>{textChooser('txt160')}: {createdAtText}
                    </span>
                    {isNew && <TagNew />}
                </div>
                <div className="opportunity-location">
                    <div className="row">
                        <div className="col-xs-4 col-sm-3">
                            <TextIcon 
                                type="location" 
                                text={`Peru, ${converIdToText(props.address, 'geoDepartments').toLowerCase()}`}
                            />
                        </div>
                        <div className="col-xs-4 col-sm-3">
                            <TextIcon 
                                type="workMode" 
                                text={converIdToText(props.typeWorkId, 'workPlace')}
                            />
                        </div>
                        <div className="col-xs-4 col-sm-3">
                            <TextIcon 
                                type="hours" 
                                text={converIdToText(props.typeWorkTimeId, 'workHours')}
                            />
                        </div>
                    </div>
                </div>
            </ColInformation>

            <ColControllers>
                {/* <FavoriteToggleBtn
                    isActive={false}
                    opportunityId={props.id}
                    onSuccess={() => {}}
                /> */}
                <span/>
                {props.opportunitySubscriptions.find(_ => _.customerId === userId) ? 
                    <Button disabled full>
                        <strong>
                            {textChooser("txt157")}
                        </strong>
                    </Button>
                    : 
                    <Button primary full>
                        <Link className="text colorWhite" to={opportunityUrl}>
                            {textChooser("txt64")}
                        </Link>
                    </Button>
                }
                
            </ColControllers>
        </CardOpportunityWrapper>
    );
}